import { useEffect, useRef } from "react";
import * as serviceWorkerRegistration from "src/serviceWorkerRegistration";

export default function useRegisterServiceWorker({
  setUpdateAvailable,
}: {
  setUpdateAvailable?: (updateAvailable: boolean) => void;
}) {
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    serviceWorkerRegistration.register({
      onUpdate: () => {
        setUpdateAvailable?.(true);
      },
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
